import React from 'react'
import styled from 'styled-components'

const Page = styled.div`
  max-width: 48rem;
  min-height: 100%;
  padding: 1rem;
  background-color: white;

  @media (min-width: 32rem) {
    padding: 2rem;
  }

  @media (min-width: 64rem) {
    padding: 3rem;
  }
`

const PageComponent = ({children, style}) => (
  <Page style={style}>
    {children}
  </Page>
)

export default PageComponent



// WEBPACK FOOTER //
// ./src/components/page.js